// ListeLoader.jsx
import React from "react";

const ListeLoader = () => {
  return (
    <div className="containerMain flex flex-col gap-8 animate-pulse">
      <div className="flex justify-between items-center gap-8 h-[72px] bg-gray-100 w-full max-w-[320px] rounded-2xl "></div>
      <div className="container liste grid grid-cols-1 place-items-center sm:grid-cols-2 lg:grid-cols-3 gap-4 xl:grid-cols-4">
        {Array.from({ length: 20 }).map((_, index) => (
          <div
            key={index}
            className="rounded-2xl w-full max-w-[320px] p-4 h-[96px] bg-gray-100 "
          ></div>
        ))}
      </div>
    </div>
  );
};

export default ListeLoader;
